import { defineComponent, defineAsyncComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import OverviewWrapper from './OverviewWrapper.CB';
import Popup from '@/presentation/components/Popup/Popup.vue';

export default defineComponent({
	components: {
		Popup,
		Overview: defineAsyncComponent(() => import('../Overview/Overview.vue')),
	},
	setup: () => {
		const codeBehind = new OverviewWrapper();

		return setupComponent(codeBehind);
	},
});
